var _a;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import { checkWorkspaceRoleApi } from '@cores/apis/workspace_api/workspace';
import { I18nService } from '@/services/i18n-service';
let CheckSpaceRoleServiceImpl = class CheckSpaceRoleServiceImpl {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    async check(userId) {
        const result = await checkWorkspaceRoleApi({
            user_id: userId,
        });
        if (result.status === 'OK') {
            return '';
        }
        else if (result.status === 'SELF') {
            return this._i18nService.t('commonStatusCode.70110021');
        }
        else if (result.status === 'NO_PERMISSION') {
            return this._i18nService.t('commonStatusCode.70110008');
        }
        else if (result.status === 'NO_SHARE_PERMISSION') {
            return this._i18nService.t('commonStatusCode.70110419');
        }
        return result.status;
    }
};
CheckSpaceRoleServiceImpl = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], CheckSpaceRoleServiceImpl);
export { CheckSpaceRoleServiceImpl };
